var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbtUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_message-question",
    "data-name": "vuesax/linear/message-question",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-question",
    transform: "translate(620 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.875,12.667H8.708L5.185,15.01a.789.789,0,0,1-1.227-.657V12.667A3.74,3.74,0,0,1,0,8.708V3.958A3.74,3.74,0,0,1,3.958,0h7.917a3.74,3.74,0,0,1,3.958,3.958v4.75A3.74,3.74,0,0,1,11.875,12.667Z",
    transform: "translate(1.583 1.924)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1.314,3.563V3.4a1.24,1.24,0,0,1,.665-1.053,1.214,1.214,0,0,0,.649-1.029A1.314,1.314,0,1,0,0,1.314",
    transform: "translate(8.186 5.431)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.5.5H.5",
    transform: "translate(9.001 10.385)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbtUs);
export default __webpack_public_path__ + "static/media/abt-us.4f8ec481c5ce4cc91d8049ca12e0a89e.svg";
export { ForwardRef as ReactComponent };